<template>
  <v-form ref="form" fast-fail @submit.prevent v-model="valid" class="inherit-height scroll-container">
    <!--    <div-->
    <!--      v-if="darkMode"-->
    <!--      :style="{ backgroundColor: backgroundColorReversed, color: backgroundColor ? '#fff' : '#000' }"-->
    <!--      class="px-4 py-2 d-flex justify-end"-->
    <!--    >-->
    <!--      <v-btn-->
    <!--        class="d-flex"-->
    <!--        color="accent"-->
    <!--        :dark="mode === 'light'"-->
    <!--        :light="mode === 'dark'"-->
    <!--        @click="overwriteBackgroundColor = !overwriteBackgroundColor"-->
    <!--        >{{ overwriteBackgroundColor ? $t('forms.toDarkMode') : $t('forms.toOriginalBackground') }}-->
    <!--        {{ $t('forms.changeDarkLightMode') }}-->
    <!--      </v-btn>-->
    <!--    </div>-->

    <div id="form-content" :class="xs ? 'ma-0 pa-0' : 'ma-1 pa-1 pb-0 pt-0'" class="hide-scrollbar" :style="contentStyle" :dense="xs">
      <v-card-text class="form-fields pb-0" :style="formFieldContainerStyle">
        <span v-for="field in formbuilderdata" :key="field.cid || 'row-' + field.length + field[0].cid" class="ma-1">
          <v-row v-if="Array.isArray(field)">
            <v-col v-for="rowField in field" :key="'row-field-' + rowField.cid" class="py-1">
              <component
                :class="rowField.field_type === 'section_break' ? '' : 'form-component'"
                :is="getMappedComponent(rowField.field_type)"
                :field="rowField"
                :formModel="formModel"
                :mediasModel="mediasModel"
                :readonly="displayedForm.submitted === 1 && displayedForm.allowEdit === 0 && displayedForm.allowMultipleSubmit === 0"
                :mode="mode"
                @formUpdated="(k, v) => formUpdated(k, v)"
              />
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col v-if="!isHiddenComponent(field.field_type)" class="py-1">
              <component
                :class="field.field_type === 'section_break' ? '' : 'form-component'"
                :is="getMappedComponent(field.field_type)"
                :field="field"
                :formModel="formModel"
                :mediasModel="mediasModel"
                :readonly="displayedForm.submitted === 1 && displayedForm.allowEdit === 0 && displayedForm.allowMultipleSubmit === 0"
                :mode="mode"
                @formUpdated="(k, v) => formUpdated(k, v)"
            /></v-col>
          </v-row>
        </span>
      </v-card-text>
      <div class="form-actions pt-2">
        <div class="d-flex">
          <v-btn class="mr-2" color="secondary-action" rounded @click="$emit('resetForm')">{{ $t('reset') }}</v-btn>
          <v-btn
            rounded
            class="mr-3"
            :color="!valid ? 'primary-action' : 'primary-action lighten-4'"
            :disabled="!valid || disableSendButton || hideSendBtn"
            @click="sendForm"
          >
            <v-icon v-if="isSending" class="pl-2" left> mdi-cog mdi-spin </v-icon>
            {{ $t('send') }}
          </v-btn>
        </div>
        <div class="d-flex flex-grow-1 justify-end px-2 py-2 caption" :class="infoTextColor">{{ infoText }}</div>
      </div>
    </div>
  </v-form>
</template>

<script>
import TableEditor from './editors/TableEditor.vue';
import formsMixin from './formsMixin';
import AddressEditor from './editors/AddressEditor.vue';
import DateEditor from './editors/DateEditor.vue';
import TimeEditor from './editors/TimeEditor.vue';
import FileEditor from './editors/FileEditor.vue';
import configMixin from '@/mixins/configMixin';
import common from '@/mixins/common'; //Needed for isToolbarsHidden
import CheckboxEditor from './editors/CheckboxEditor.vue';
import RadioEditor from './editors/RadioEditor.vue';
import SignatureEditor from './editors/SignatureEditor.vue';
import TextFieldEditor from './editors/TextFieldEditor.vue';
import TextAreaEditor from './editors/TextAreaEditor.vue';
import DropdownEditor from './editors/DropdownEditor.vue';
import StaticLinkEditor from './editors/StaticLinkEditor.vue';
import ShowImage from './editors/ShowImage.vue';
import TextView from './editors/TextView.vue';
import RangeEditor from './editors/RangeEditor.vue';
import DynamicDropdownEditor from '@/modules/forms/editors/DynamicDropdownEditor.vue';
import NotImplementedEditor from '@/modules/forms/editors/NotImplementedEditor.vue';
import QRCodeEditor from '@/modules/forms/editors/QRCodeEditor.vue';

export default {
  components: {
    DynamicDropdownEditor,
    TextView,
    ShowImage,
    StaticLinkEditor,
    SignatureEditor,
    RadioEditor,
    CheckboxEditor,
    TextFieldEditor,
    TextAreaEditor,
    DropdownEditor,
    AddressEditor,
    FileEditor,
    DateEditor,
    TimeEditor,
    TableEditor,
    QRCodeEditor,
    RangeEditor,
  },
  mixins: [formsMixin, configMixin, common],
  props: {
    displayedForm: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true, default: () => [] },
    dataLoaded: { type: Boolean, required: false, default: true },
    disableSendButton: { type: Boolean, required: false, default: false },
  },
  emits: ['formUpdated', 'resetForm', 'sendForm'],
  data: () => ({
    valid: true,
    hideSendBtn: false,
    isSending: false,
    infoText: undefined,
    infoTextColor: 'info',
    overwriteBackgroundColor: false,
  }),
  mounted() {
    this.$refs.form.validate();
  },
  computed: {
    routeFormId() {
      return this.$route.params.formId;
    },
    mode() {
      if (this.darkMode) {
        return this.overwriteBackgroundColor ? 'light' : 'dark';
      }
      return 'light';
    },
    backgroundColor() {
      // map for beautyfing colors
      // const niceColors={'#CDFDA2':'#e0f6cc','#FFFFBB':'#f7f7dd'}
      const niceColors = {
        '#CDFDA2': '#CDFDA2', // green
        '#FFFFBB': '#FFFFBB', // yellow unchanged
      };
      let background = this.displayedForm && this.displayedForm.backgroundcolor;

      console.debug(`this.darkMode=${this.darkMode} background=${background}`);
      if (this.darkMode && ['white', '#FFFFFF', '#FFF', '#ffffff', '#fff'].includes(background)) {
        background = '#101010';
      }
      console.debug('background color form', background);
      if (niceColors[background]) {
        background = niceColors[background];
      }
      return background;
    },
    contentStyle() {
      let style = {};

      style.height = `calc(100vh - ${this.toolbarsHeight - 48}px)`;
      style.backgroundColor = this.backgroundColor;
      style.overflow = 'hidden';

      return style;
    },
    formFieldContainerStyle() {
      let style = {};

      style.height = `calc(100% - ${this.xs ? 72 : 72}px)`;

      return style;
    },
    formbuilderdata() {
      //Preprocess formbuilderdata to create layout correctly
      const fieldsByRow = [];
      const staticFormContent = [
        {
          field_type: 'section_break',
          field_options: {},
          isStaticForm: true,
          label: 'Statische Formulare sind noch nicht implementiert :(',
          cid: 'c1',
        },
      ];
      const formbuilderdata = this.displayedForm.formbuilderdata;

      if (!formbuilderdata) return staticFormContent;

      // const fields = JSON.parse(formbuilderdata).fields;
      const fields = formbuilderdata.fields;

      if (fields.length === 0) {
        return staticFormContent;
      }

      let appendNextField = false;
      let currentRow = [];
      fields.forEach((field) => {
        if (appendNextField && !field.field_options.floatfield) {
          //Previous field was floatfield=true
          //Add here only if floatfield=false so that it doesn't get added twice
          currentRow.push(field);
        }

        if (field.field_options.floatfield) {
          appendNextField = true; //Next field must be in same row
          currentRow.push(field);
        } else {
          appendNextField = false;
          if (currentRow.length > 0) {
            //Append Row to fieldsByRow and reset currentRow
            fieldsByRow.push(currentRow);
            currentRow = [];
          } else {
            //Field is not in a row - just add it to fieldsByRow
            fieldsByRow.push(field);
          }
        }
      });
      if (currentRow.length > 0) {
        fieldsByRow.push(currentRow);
      }

      return fieldsByRow;
    },
  },
  updated() {
    this.setInfoText();
  },
  methods: {
    formUpdated(k, v) {
      this.$emit('formUpdated', k, v);
    },
    isHiddenComponent(type) {
      return HIDDEN_COMPONENTS.includes(type);
    },
    getMappedComponent(type) {
      let comp = COMPONENT_NAME_MAPPING[type];
      if (comp) return comp;
      return NotImplementedEditor;
    },
    async sendForm() {
      //const { valid } = await this.$refs.form.validate();
      this.isSending = true;
      if (this.valid) {
        const data = [];

        for (const [key, cell] of Object.entries(this.formModel)) {
          if (cell === undefined || cell === null) {
            //Ignore undefined and null values
            continue;
          } else if (Array.isArray(cell)) {
            //Handle checkbox values
            cell.forEach((row) => {
              Object.keys(row).forEach((col) => {
                //Save like: [...{"name": "c3", "value": "2021-10-28"},{"name": "c3", "value": "some-val"}...]
                data.push({ name: key, value: row[col] });
              });
            });
            continue;
          } else if (typeof cell === 'object') {
            //Handle checkbox values
            Object.keys(cell)
              .filter((k) => cell[k] === true)
              .forEach((k) => {
                //Save like: [...{"name": "c16", "value": "CB1"},{"name": "c16", "value": "CB3"}...]
                data.push({ name: key, value: k });
              });
            continue;
          }
          data.push({ name: key, value: cell });
        }

        await this.$emit('sendForm', { formData: data, mediaData: this.mediasModel });

        this.setInfoText();
        this.isSending = false;
      } else {
        this.$store.commit('snackbar/displaySnackbar', { text: this.$t('fix.errors.beforeSend') });
        this.isSending = false;
      }
    },
    setInfoText() {
      if (this.displayedForm != undefined) {
        if (this.displayedForm.submitted === 1 && this.displayedForm.allowEdit === 0 && this.displayedForm.allowMultipleSubmit === 0) {
          this.infoText = this.$t('module.forms.property.restirctions.alreadySent');
          this.infoTextColor = 'red--text';
          this.hideSendBtn = true;
        } else if (this.displayedForm.allowEdit === 1 && this.displayedForm.allowMultipleSubmit === 0) {
          this.infoText = this.$t('module.forms.property.restrictions.edit');
          this.infoTextColor = '';
          this.hideSendBtn = false;
        } else if (this.displayedForm.allowEdit === 0 && this.displayedForm.allowMultipleSubmit === 0) {
          this.infoText = this.$t('module.forms.property.restrictions.singlesubmit');
          this.infoTextColor = '';
          this.hideSendBtn = false;
        } else if (this.displayedForm.allowEdit === 0 && this.displayedForm.allowMultipleSubmit === 1) {
          this.infoText = this.$t('module.forms.property.restirctions.multiplesubmit');
          this.infoTextColor = '';
          this.hideSendBtn = false;
        }
      }
    },
  },
  watch: {
    routeFormId(newVal) {
      if (localStorage.getItem('forms')) {
        let storedForms = JSON.parse(localStorage.getItem('forms') || '{}');
      }
    },
    $route() {
      if (this.$refs.scrollContainer) this.$refs.scrollContainer.scrollTop = 0; //Scroll to top of view on change

      // reset form and validation on form change
      //this.$emit('resetForm');
      this.$refs.form.resetValidation();
    },
    displayedForm: {
      immediate: true,
      handler(form) {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      },
    },
    formbuilderdata: {
      immediate: true,
      handler(v) {
        if (v.length === 1 && v[0].isStaticForm) {
          //Is static form (see formbuilder computed property)
          this.hideSendBtn = true;
        }
      },
    },
  },
};
let HIDDEN_COMPONENTS = ['page_break'];
let COMPONENT_NAME_MAPPING = {
  text: TextFieldEditor,
  email: TextFieldEditor,
  number: TextFieldEditor,
  paragraph: TextAreaEditor,
  dropdown: DropdownEditor,
  dynamicDropdown: DynamicDropdownEditor,
  table: TableEditor,
  address: AddressEditor,
  date: DateEditor,
  time: TimeEditor,
  file: FileEditor,
  checkboxes: CheckboxEditor,
  radio: RadioEditor,
  static_link: StaticLinkEditor,
  image: ShowImage,
  signature: SignatureEditor,
  section_break: TextView,
  range: RangeEditor,
  qrcode: QRCodeEditor,
};
</script>

<style scoped>
.form-fields {
  overflow: auto;
}

.form-actions {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  position: fixed;
  left: 0;
  right: 0;
  padding-top: 10px;
  bottom: 0px;
  opacity: 1;
}
.theme--dark .form-actions {
  background: #202020;
  border-top: 1px solid #404040;
  border-bottom: 1px solid #404040;
}

.theme--light .form-actions {
  background: #fefefe;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
</style>
